export const INIT_RESOCONTO_MESE_REDUCER = 'INIT_RESOCONTO_MESE_REDUCER';
export const INIT_RESOCONTO_MESE_ACTION = 'INIT_RESOCONTO_MESE_ACTION';

export const RICERCA_TIMBRATURE_START_REGISTRO_ACTION = 'RICERCA_TIMBRATURE_START_REGISTRO_ACTION';


export const GET_TIMBRATURE_PER_MESE_SINGOLO_INDIVIDUO_SUCCESS = 'GET_TIMBRATURE_PER_MESE_SINGOLO_INDIVIDUO_SUCCESS';
export const GET_TIMBRATURE_PER_MESE_SCR_SUCCESS = 'GET_TIMBRATURE_PER_MESE_SCR_SUCCESS';
export const GET_TIMBRATURE_TOTALI_PER_MESE_SUCCESS = 'GET_TIMBRATURE_TOTALI_PER_MESE_SUCCESS';

//uniformati i success in
export const RICERCA_TIMBRATURE_START_REGISTRO_END = 'RICERCA_TIMBRATURE_START_REGISTRO_END';

export const GET_TIMBRATURE_PER_MESE_FAIL = 'GET_TIMBRATURE_PER_MESE_FAIL';

export const SET_INDIVIDUI_SELEZIONATI_REGISTRO = 'SET_INDIVIDUI_SELEZIONATI_REGISTRO';
